import React from 'react';
import { t } from 'i18next';

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { theme } from '@frontend/theme';


type Props = {
  open: boolean;
  remarks: string;
  onClose: () => void;
};

export const RemarksModal: React.FC<Props> = ({ open, onClose, remarks }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm">
      <DialogTitle>{t('hotels.fares.remarks')}</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            '.ck-content': {
              ...theme.typography.body2,
              border: 'none'
            },
            '.ck-reset_all': {
              display: 'none',
            },
            mt: theme.spacing(2)
          }}
        >
        <CKEditor
          editor={ClassicEditor}
          data={remarks}
          disabled
          config={{
            toolbar: [],
          }}
        />
      </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>{t('common.close')}</Button>
      </DialogActions>
    </Dialog>
);
